import React from 'react';
import { SlaSettingsApp } from '@atlassian/jira-servicedesk-sla-settings/src/ui/index.tsx';
import { ServiceDeskDocumentTitle } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/document-title/index.tsx';
import { usePageContext } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/page-context/main.tsx';
import AppContainer from '@atlassian/jira-spa-apps-project-settings-common/src/components/app-container';

export const ServiceDeskSlaSettingsView = () => {
	const [{ data: pageContextData }] = usePageContext();
	const { projectContext } = pageContextData || {};

	const { projectKey, projectName } = projectContext || {};

	return (
		// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
		<AppContainer baseUrl="" projectKey={projectKey}>
			{/* @ts-expect-error - TS2322 - Type '{ projectName: string | undefined; section: string; }' is not assignable to type 'IntrinsicAttributes & Diff<(Diff<RefAttributes<any> | (RefAttributes<any> & { children?: ReactNode; }), Partial<RefAttributes<...> | (RefAttributes<...> & { ...; })>> & RefAttributes<...>) | (Diff<...> & ... 1 more ... & { ...; }), InjectIntlVoidProps> & { ...; }'. */}
			<ServiceDeskDocumentTitle projectName={projectName} section="sla" />
			<SlaSettingsApp />
		</AppContainer>
	);
};
